export default "/assets/website/images/hero-img-giveaway.png?45caf2b65656d14f35cbcd5ddbd024aa";